import actions from './actions';
import reducer from './reducer';
import selectors from './selectors';
import { AsyncStatus, License } from '../../types';

export interface LicensesStore {
  licenses: {[key in string]: License };
  status: AsyncStatus;
}

export default { actions, reducer, selectors };
